const formatNotificationDate = (content: string): string => {
  // Match full ISO datetime like 2025-10-28T09:30:00.000000Z
  const dateMatch = content.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z/);
  if (!dateMatch) return content;

  // Parse as UTC
  const date = new Date(dateMatch[0]);

  // Format to: "October 28, 2025 9:30 AM"
  const formattedDate = date.toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  // Replace ISO string with formatted date
  return content.replace(dateMatch[0], formattedDate);
};

export { formatNotificationDate }